import axiosService from "./axios.service";

export interface Pricing {
    currency: string;
    // in the currency's smallest unit (cents)
    proEventPrice: number;
    free: string[];
    pro: string[];
    // how many ideas a Free event holds
    freeIdeaLimit?: number;
    // Stripe test mode: no real money moves
    testMode: boolean;
    // false when the server can't take payments (no key, or a live key that isn't allowed)
    available: boolean;
}

export interface BillingStatus {
    plan: 'free' | 'pro';
    planUpgradedAt: Date | null;
    // made Pro by Persera rather than paid for
    granted: boolean;
    pricing: Pricing;
    purchases: Array<{ amount: number, currency: string, paidAt: Date | null, testMode: boolean, paidBy: { username?: string, email?: string } | null }>;
}

const toStatus = (data: any): BillingStatus => ({
    ...data,
    planUpgradedAt: data.planUpgradedAt ? new Date(data.planUpgradedAt) : null,
    granted: !!data.granted,
    purchases: (data.purchases || []).map((p: any) => ({ ...p, paidAt: p.paidAt ? new Date(p.paidAt) : null }))
});

/** "$99" / "CA$99.50" in the viewer's locale. */
export const formatPrice = (amount: number, currency: string) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.toUpperCase(), minimumFractionDigits: amount % 100 ? 2 : 0 }).format(amount / 100);

export { FREE_IDEA_LIMIT, ideaAllowance } from '../utils/plans';

export const getPricing = async (): Promise<Pricing> => (await axiosService.get('/api/pricing')).data;

export const getBilling = async (hackathonId: string) => toStatus((await axiosService.get(`/api/hackathons/${hackathonId}/billing`)).data);

/** Starts Stripe Checkout; resolves with the URL to send the organizer to. */
export const startCheckout = async (hackathonId: string): Promise<string> =>
    (await axiosService.post(`/api/hackathons/${hackathonId}/billing/checkout`)).data.url;

export const confirmCheckout = async (hackathonId: string, sessionId: string) =>
    toStatus((await axiosService.post(`/api/hackathons/${hackathonId}/billing/confirm`, { sessionId })).data);
